import { useEffect } from "react";
import { S1MonthlyCommentsCard } from "./card";
import { S1MonthlyCommentsNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S1MonthlyCommentsTable } from "./table";

export default function S1MonthlyComments() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Commentaires S1");
  }, []);

  return (
    <Routes>
      <Route index element={<S1MonthlyCommentsTable />} />
      <Route path="/new" element={<S1MonthlyCommentsNew />} />
      <Route path=":id" element={<S1MonthlyCommentsCard />} />
    </Routes>
  );
}
